import { Box, Paper, Skeleton, Stack } from "@mui/material";

/** Widths mirror the workspace meta pills (User / Action / Vendor / SSN). */
const META_PILL_WIDTHS = [150, 112, 132, 104];

/**
 * Placeholder for the major job workspace while the major job and its task jobs
 * load. Geometry follows the real panel so nothing jumps when data lands.
 */
export default function MajorJobWorkspaceSkeleton() {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
      }}
    >
      <Box
        sx={{
          mb: 1.5,
          display: "flex",
          justifyContent: "space-between",
          gap: 1,
          alignItems: "flex-start",
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ minWidth: 0, flex: "1 1 auto" }}>
          <Skeleton variant="text" width={220} sx={{ fontSize: "1.05rem" }} />
          <Box
            sx={{
              display: { xs: "grid", sm: "flex" },
              gridTemplateColumns: {
                xs: "repeat(2, minmax(0, 1fr))",
                sm: "none",
              },
              flexWrap: { sm: "wrap" },
              gap: 1,
              mt: 0.75,
            }}
          >
            {META_PILL_WIDTHS.map((w) => (
              <Skeleton
                key={w}
                variant="rounded"
                height={52}
                sx={{ width: { xs: "100%", sm: w } }}
              />
            ))}
          </Box>
        </Box>
        <Stack
          direction="row"
          spacing={1}
          sx={{ width: { xs: "100%", sm: "auto" } }}
        >
          <Skeleton
            variant="rounded"
            height={31}
            sx={{ flex: { xs: 1, sm: "0 0 auto" }, width: { sm: 128 } }}
          />
          <Skeleton
            variant="rounded"
            height={31}
            sx={{ flex: { xs: 1, sm: "0 0 auto" }, width: { sm: 152 } }}
          />
        </Stack>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          alignItems: "center",
          minHeight: 40,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Skeleton variant="text" width={68} />
        <Skeleton variant="text" width={60} />
        <Skeleton variant="text" width={84} />
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          flexWrap: "wrap",
          mt: 2,
          mb: 1,
        }}
      >
        <Skeleton variant="text" width={72} />
        <Stack
          direction="row"
          spacing={1}
          sx={{ ml: "auto", width: { xs: "100%", sm: "auto" } }}
        >
          <Skeleton
            variant="rounded"
            height={31}
            sx={{ flex: { xs: 1, sm: "0 0 auto" }, width: { sm: 118 } }}
          />
          <Skeleton
            variant="rounded"
            height={31}
            sx={{ flex: { xs: 1, sm: "0 0 auto" }, width: { sm: 118 } }}
          />
        </Stack>
      </Box>

      <Box
        sx={{
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          px: 1.5,
          py: 1,
        }}
      >
        {Array.from({ length: 8 }).map((_, i) => (
          <Box
            key={i}
            sx={{ display: "flex", alignItems: "center", gap: 2, py: 0.85 }}
          >
            <Skeleton variant="text" sx={{ flex: 1 }} />
            <Skeleton variant="rounded" width={78} height={22} />
            <Skeleton variant="text" width={34} />
            <Skeleton variant="text" width={34} />
            <Skeleton variant="rounded" width={88} height={24} />
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
